if (!customElements.get('related-products-slider')) {
  class RelatedProductsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.related-products__track');
      this.prevBtn = this.querySelector('.related-products__btn--prev');
      this.nextBtn = this.querySelector('.related-products__btn--next');
      this.columns = parseInt(this.dataset.columnsDesktop) || 4;
      this.currentIndex = 0;
      this._initialized = false;

      this._mq = window.matchMedia('(min-width: 990px)');
      this._mq.addEventListener('change', (e) => {
        if (e.matches) {
          this._initialized = false;
          this._init();
        } else {
          this.track.style.transform = '';
          this.currentIndex = 0;
          this._initialized = false;
        }
      });

      if (this._mq.matches) this._init();
    }

    _init() {
      if (this._initialized) return;
      this._initialized = true;

      this.items = [...this.track.querySelectorAll(':scope > .grid__item')];
      this.totalItems = this.items.length;
      this.maxIndex = Math.max(0, this.totalItems - this.columns);

      if (this.totalItems <= this.columns) {
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
        return;
      }

      if (this.prevBtn) this.prevBtn.hidden = false;
      if (this.nextBtn) this.nextBtn.hidden = false;

      this._onPrev = () => this._go(this.currentIndex - this.columns);
      this._onNext = () => this._go(this.currentIndex + this.columns);
      this.prevBtn?.addEventListener('click', this._onPrev);
      this.nextBtn?.addEventListener('click', this._onNext);

      this._initSwipe();
      this._update();
    }

    _itemStep() {
      if (this.items.length < 2) return this.items[0]?.offsetWidth || 0;
      return this.items[1].offsetLeft - this.items[0].offsetLeft;
    }

    _go(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.track.style.transform = `translateX(-${this.currentIndex * this._itemStep()}px)`;
      this._update();
    }

    _update() {
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }

    _initSwipe() {
      let startX = 0, startY = 0, tracking = false;

      this.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = startX - e.changedTouches[0].clientX;
        const dy = startY - e.changedTouches[0].clientY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          dx > 0 ? this._go(this.currentIndex + this.columns) : this._go(this.currentIndex - this.columns);
        }
      }, { passive: true });

      this.addEventListener('touchmove', (e) => {
        if (!tracking) return;
        const dx = Math.abs(startX - e.touches[0].clientX);
        const dy = Math.abs(startY - e.touches[0].clientY);
        if (dx > dy) e.preventDefault();
      }, { passive: false });
    }
  }

  customElements.define('related-products-slider', RelatedProductsSlider);
}
